export enum ProjectStatus {
  None,
  InProgress,
  Completed,
  Failed,
  Cancelled,
  Archived,
}
